<template>
  <div style="width:100%;">
    <div class="header" :class="{ 'scrolled': isScrolled }">
      <div class="header-content">
        <div class="header-img">
          <img style="margin-top:2px" src="../assets/images/logo.png" />
        </div>
        <div class="header-tab">
          <el-menu
            :default-active="activeIndex"
            class="el-menu-demo"
            mode="horizontal"
            :router="true"
            :text-color="isScrolled ? '#333' : '#fff'"
            active-text-color="#0285ff"
            @select="handleSelect"
          >
            <el-menu-item
              v-for="item in menuItem.children"
              :key="item.path"
              :index="item.path"
            >{{item.zhName}}</el-menu-item>
          </el-menu>
        </div>
        <div class="header-right">
          <!-- <div @click="btn()">朗云通用平台</div> -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      activeIndex: "/HomePage",
      menuItem: [],
      isScrolled: false, // 跟踪是否滚动
    };
  },
  mounted() {
    this.activeIndex = this.$route.fullPath;
    this.getRouteMenu();
    // 添加滚动监听
    window.addEventListener('scroll', this.handleScroll);
  },
  beforeDestroy() {
    // 移除滚动监听，防止内存泄漏
    window.removeEventListener('scroll', this.handleScroll);
  },
  watch: {
    $route(to, from) {
      this.activeIndex = to.path;
      console.log("to", to, from);
    },
  },
  methods: {
    btn(){
      window.location.href = 'https://lyup.langyuniot.com/';
    },
    getRouteMenu() {
      let menuItem = this.$router.options.routes[0];
      // 过滤掉没有 zhName 的路由项（如案例详情路由）
      if (menuItem && menuItem.children) {
        menuItem.children = menuItem.children.filter(item => item.zhName);
      }
      this.menuItem = menuItem;
    },
    handleSelect(key, keyPath) {
      console.log(key, keyPath);
    },
    handleScroll() {
      // 当滚动超过 50px 时，添加背景色
      this.isScrolled = window.scrollY > 50;
    }
  },
};
</script>

<style lang='less' scoped>
.header {
  display: flex;
  justify-content: center; // 居中内容容器
  height: 80px;
  width: 100%; // 100% 宽度
  position: fixed; // 固定定位
  top: 0;
  left: 0;
  z-index: 1000; // 确保在最上层
  background: transparent; // 初始透明背景
  transition: all 0.3s ease; // 平滑过渡效果
  box-shadow: none; // 初始无阴影
  
  // 滚动后的样式
  &.scrolled {
    background: rgba(255, 255, 255, 0.98); // 几乎不透明的白色背景
    backdrop-filter: blur(10px); // 毛玻璃效果
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1); // 添加阴影
    
    .header-right {
      color: #0285ff !important;
    }
  }
  
  // 内容容器，限制宽度为 1200px 并居中
  .header-content {
    display: flex;
    // justify-content: space-between;
    align-items: center;
    width: 80%; // 限制内容宽度
    height: 100%;
    
    .header-img {
      margin: 15px 0 0 0;
      img {
        width: 112px;
        height: 46px;
        margin-top: 0;
      }
    }

    .header-tab {
      margin-left: 80px;
      .el-menu {
        height: 80px;
        line-height: 80px;
        background: transparent !important; // 菜单背景透明
        
        .el-menu-item {
          height: 80px;
          line-height: 80px;
          font-size: 16px;
          padding: 0 40px;
          background: transparent !important; // 菜单项背景透明
          
          &:hover {
            background: rgba(2, 133, 255, 0.1) !important; // 悬停时显示淡蓝色背景
          }
        }
        .el-menu-item.is-active {
          border: none;
          // border-bottom: 2px solid #0285ff;
          // color: #0285ff !important;
        }
        .el-menu.el-menu--horizontal {
          border-bottom: none !important;
        }
      }
    }
    
    .header-right{
      line-height: 80px;
      font-size: 14px;
      color: #0285ff;
      
      div {
        cursor: pointer;
        
        &:hover {
          opacity: 0.8;
        }
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/TopNav.vue